import { IColumnTypes } from 'components/spreadsheet/types'

// Duplicate validation compares values as exact strings for every column kind except
// Email, where `Ali@morta.io` and `ali@morta.io` are the same mailbox. Only the key a
// value is tallied under in `columnValuesCount` is folded — stored values are never
// rewritten, and no other email normalisation is applied.

export const isCaseInsensitiveDuplicateKind = (kind?: IColumnTypes): boolean => kind === 'email'

/** Public ids of the columns whose duplicate tally must ignore case. */
export const getCaseInsensitiveDuplicateColumnIds = (
  ...columnLists: (readonly { publicId: string; kind: IColumnTypes }[] | undefined)[]
): Set<string> => {
  const columnIds = new Set<string>()
  for (const columns of columnLists) {
    for (const column of columns ?? []) {
      if (isCaseInsensitiveDuplicateKind(column.kind)) columnIds.add(column.publicId)
    }
  }
  return columnIds
}

/** The key a cell value is tallied under in `columnValuesCount`. */
export const getDuplicateValueKey = (value: string, caseInsensitive: boolean): string =>
  caseInsensitive && typeof value === 'string' ? value.toLowerCase() : value
